import React, { useState, useEffect } from 'react';
import api from '../api';
import { Link } from 'react-router-dom';
import DashboardNav from './DashboardNav';
import LiveBusMap from './LiveBusMap';
import LoadingSpinner from './LoadingSpinner';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    registeredParents: 0,
    students: 0,
    registeredBuses: 0,
    approvalRequests: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const config = {
          headers: {
            'x-auth-token': token,
          },
        };

        // Fetch counts from backend (assuming these endpoints exist)
        const [parentsRes, studentsRes, busesRes, approvalRequestsRes] = await Promise.all([
          api.get('/parents/count', config),
          api.get('/students/count', config),
          api.get('/buses/count', config),
          api.get('/approval-requests/count', config)
        ]);

        setStats({
          registeredParents: parentsRes.data.count,
          students: studentsRes.data.count,
          registeredBuses: busesRes.data.count,
          approvalRequests: approvalRequestsRes.data.count,
        });
      } catch (err) {
        console.error('Error fetching dashboard stats:', err.response ? err.response.data : err.message);
        setError('Failed to load dashboard data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>School Dashboard</h1>
        <DashboardNav />
      </header>
      
      {error && (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      )}
      
      <div className="stats-cards">
        {isLoading ? (
          <>
            <div className="stat-card">
              <h2>Registered Parents</h2>
              <div className="stats-loading">
                <LoadingSpinner size="small" message="" />
              </div>
            </div>
            <div className="stat-card">
              <h2>Students</h2>
              <div className="stats-loading">
                <LoadingSpinner size="small" message="" />
              </div>
            </div>
            <div className="stat-card">
              <h2>Registered Buses</h2>
              <div className="stats-loading">
                <LoadingSpinner size="small" message="" />
              </div>
            </div>
            <div className="stat-card">
              <h2>Approval Requests</h2>
              <div className="stats-loading">
                <LoadingSpinner size="small" message="" />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="stat-card">
              <h2>Registered Parents</h2>
              <p>{stats.registeredParents}</p>
            </div>
            <div className="stat-card">
              <h2>Students</h2>
              <p>{stats.students}</p>
            </div>
            <div className="stat-card">
              <h2>Registered Buses</h2>
              <p>{stats.registeredBuses}</p>
            </div>
            <div className="stat-card">
              <h2>Approval Requests</h2>
              <p>{stats.approvalRequests}</p>
            </div>
          </>
        )}
      </div>

      <section className="overview-map-section">
        <h2>Live Bus Locations</h2>
        <div className="map-controls">
          <div className="toggle-buttons">
            <button className="toggle-button active">Live Buses</button>
            <button className="toggle-button">Route Stops</button>
            <button className="toggle-button">Route Lines</button>
          </div>
          <div className="bus-dropdown">
            <label htmlFor="bus-select">Focus on Bus:</label>
            <select id="bus-select">
              <option value="">All Buses</option>
              {/* Map bus options here */}
            </select>
          </div>
        </div>
        <div className="embedded-map">
          <LiveBusMap />
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
